import * as organizationApi from '../api/organizationApi';
import { REQUEST_LOGINUSER_ORGANIZATIONS, RECEIVE_LOGINUSER_ORGANIZATIONS_SUCCESS, REQUEST_ORGANIZATION_MERCHANT_COUNT, RECEIVE_ORGANIZATION_MERCHANT_COUNT_SUCCESS, RECEIVE_ORGANIZATION_MERCHANT_COUNT_FAILURE } from './actionTypes';

export const loadOrganizations = (userId, { parentOrgId, parentHierarchyCode, merchantNumber }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_LOGINUSER_ORGANIZATIONS });
    return organizationApi
      .getOrganizations(userId, { parentOrgId, parentHierarchyCode, merchantNumber })
      .then((apiOrgs) => {
        dispatch({
          type: RECEIVE_LOGINUSER_ORGANIZATIONS_SUCCESS,
          parentOrgId,
          parentHierarchyCode,
          apiOrgs,
        });
      });
  };
};

export const getMerchantCount = ({ parentHierarchyCode, parentOrgId }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_ORGANIZATION_MERCHANT_COUNT });
    return organizationApi
      .getMerchantCount(parentHierarchyCode, parentOrgId)
      .then((merchantCount) => {
        dispatch({
          type: RECEIVE_ORGANIZATION_MERCHANT_COUNT_SUCCESS,
          parentOrgId,
          parentHierarchyCode,
          merchantCount,
        });
      })
      .catch((error) => {
        dispatch({
          type: RECEIVE_ORGANIZATION_MERCHANT_COUNT_FAILURE,
          error,
        });
      });
  };
};

